import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-unsubscribe-email',
  templateUrl: './unsubscribe-email.component.html',
  styleUrls: ['./unsubscribe-email.component.css']
})
export class UnsubscribeEmailComponent implements OnInit {

  email:string = "";
  cilentIPAddress = '';
  unsubRespData:any;
  reason:string = "";

  constructor(private httpService:HttpService, private route:ActivatedRoute) {
    this.httpService.getIPAddress().subscribe((res: any) => {
      this.cilentIPAddress = res.ip;
    });
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.email = params['email'];
    });
  }

  unSubscribe(){
    //let url = "https://website.protectt.ai/Webapi/email/unsubscribe";
    let url = "https://dev.website.protectt.ai/Webapi/email/unsubscribe";
    let urlValue = "";
    if (url.includes("dev.website")) {
      urlValue = "nonprod"
    } else {
      urlValue = "prod"
    }
    let subData = {
      email: this.email,
      ipaddress: this.cilentIPAddress,
      reason: this.reason,
      weburl: urlValue
    }
    let data = {
      subscriptionData: subData,
    }
    let encryptMsg = JSON.stringify(data);
    let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
    let postData = {
      encryptedRequest: encMsg
    }


    this.httpService.postAPIMethod(url, postData).subscribe(
      res => {
        let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
        let decMsg = decRes;
        this.unsubRespData = JSON.parse(decMsg);
        console.log(this.unsubRespData);
      },
      error => {
      });
  }

}
